import { FascicoloLight } from '../fascicolo/fascicolo-light';
import { MetadataExt } from '../metadati/metadata';
import { PraticaBase } from './pratica-base';

export class PraticaLight extends PraticaBase {

  fascicoliLight: FascicoloLight[];
  metadata: MetadataExt[];

}
